import { render, staticRenderFns } from "./water-env.vue?vue&type=template&id=35452467&scoped=true&"
import script from "./water-env.vue?vue&type=script&lang=js&"
export * from "./water-env.vue?vue&type=script&lang=js&"
import style0 from "./water-env.vue?vue&type=style&index=0&id=35452467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35452467",
  null
  
)

export default component.exports